import { returnSizeFormatted } from "@/lib/globalFormatterHelper";

/**
 * Determines the formatted notional value from AG Grid params.
 * Used by both the Creation table (field: "notionalLeg1")
 * and Action Summary ES-level table (field: "nominal").
 */
export function formatNotionalValue(
  value: number | null | undefined,
  instrumentType: string | undefined,
): string {
  if (!value) return "";
  return returnSizeFormatted(value, instrumentType);
}
